import React from 'react';

import { Redirect, Route, RouteComponentProps, Switch, withRouter } from 'react-router';

import ErrorBoundary from '../../layouts/Portal/ErrorBoundary';
import EditTermsAndPolicyData from './Edit/EditTermsAndPolicyData';
import GeneralSettings from './GeneralSettings/GeneralSettings';
import { CreateMetafield } from './Metafields/pages/CreateMetafield';
import { EditMetafield } from './Metafields/pages/EditMetafield';
import { MetafieldDefinitions } from './Metafields/pages/MetafieldDefinitions';
import { MetafieldEntities } from './Metafields/pages/MetafieldEntities';

type Props = RouteComponentProps;

const entityRouteParams = 'catalog-item|catalog-group';

const SettingsRoutes: React.FC<Props> = (props: Props) => {
  const {
    match: { path },
  } = props;
  return (
    <ErrorBoundary identifier="settings">
      <Switch>
        <Route exact path={`${path}/general`} component={GeneralSettings} />
        <Route exact path={`${path}/legal`} component={EditTermsAndPolicyData} />
        <Route exact path={`${path}/metafields`} component={MetafieldEntities} />
        <Route
          exact
          path={`${path}/metafields/:ownerEntity(${entityRouteParams})`}
          component={MetafieldDefinitions}
        />
        <Route exact path={`${path}/metafields/:ownerEntity/create`} component={CreateMetafield} />
        <Route
          exact
          path={`${path}/metafields/:ownerEntity/:definitionKey`}
          component={EditMetafield}
        />
        <Redirect exact from={`${path}/termsandpolicydata`} to={`${path}/legal`} />
        <Redirect exact from={`${path}/`} to={`${path}/general`} />
      </Switch>
    </ErrorBoundary>
  );
};

export default withRouter(SettingsRoutes);
